import { useGtm } from '@gtm-support/vue-gtm'
import { useCartStore } from '@/stores/cart-store'
import { logger } from '@/utils/logger'

export const useEcommerceTracking = () => {
  const gtm = useGtm()
  const cartStore = useCartStore()

  const trackUserId = (userId: number | null) => {
    if (window.dataLayer && userId && userId > 0) {
      // Add userID to datalayer for GTM
      window.dataLayer.push({
        'userId': userId
      })
    }
  }

  const triggerAddToCartTrackingEvent = () => {
    triggerGtmEvent('add_to_cart')
  }

  const triggerCheckoutBeginTrackingEvent = () => {
    triggerGtmEvent('begin_checkout', {
      ...(cartStore.couponCode ? { coupon: cartStore.couponCode } : {})
    })
  }

  const triggerAddPaymentInfoTrackingEvent = (paymentType: string) => {
    triggerGtmEvent('add_payment_info', {
      payment_type: paymentType
    })
  }

  const triggerPurchaseTrackingEvent = (transactionId: number) => {
    triggerGtmEvent('purchase', {
      transaction_id: transactionId,
      tax: Number(cartStore.taxAmount),
      ...(cartStore.couponCode ? { coupon: cartStore.couponCode } : {})
    })
  }

  const triggerGtmEvent = (eventType: string, customData: object = {}) => {
    try {
      if (!gtm?.enabled() || !window.dataLayer) {
        return
      }

      const commonData = {
        checkout_type: 'express-checkout-2',
        currency: cartStore.currency,
        value: Number(cartStore.totalPrice),
        items: getProducts()
      }

      gtm.trackEvent({
        event: eventType,
        ecommerce: {
          ...commonData,
          ...customData
        }
      })
    } catch (error) {
      logger.error(error instanceof Error ? error : new Error(String(error)), {
        operation: 'track_ecommerce_event',
        event_type: eventType,
        cart_id: cartStore.cart?.uuid
      })
    }
  }

  const getProducts = () => {
    return cartStore.items.map(cartItem => ({
      item_id: cartItem.product_type.id,
      item_name: cartItem.product_type.name,
      price: cartItem.price
    }))
  }

  return {
    trackUserId,
    triggerAddToCartTrackingEvent,
    triggerCheckoutBeginTrackingEvent,
    triggerAddPaymentInfoTrackingEvent,
    triggerPurchaseTrackingEvent
  }
}
